<div class="textarea" [ngClass]="{'has-error': submitClicked && value === ''}">
  <div>
    <textarea #textAreaField appAutoGrow rows="{{rows}}" [maxlength]="maxlength" ng-minlength="1" required
      [(ngModel)]="value" placeholder="{{placeholder}}" [ngClass]="{alwaysShowBorder: alwaysShowBorder}"></textarea>
    <div class="counter">{{lengte}} / {{maxlength}}</div>
  </div>
</div>
<p class="error-block" *ngIf="submitClicked && value === ''">Geef alsjeblieft een beschrijving</p>